import { InitialStateType } from '@/modules/workingDayReconciliation/context/context';
import { IGeneral } from '@/shared/types';

export enum workingDayReconciliationActionsTypes {
  setStartDate = 'SET_START_DATE',
  setEndDate = 'SET_END_DATE',
  setAdvancedFillter = 'SET_ADVANCED_FILLTER',
  setCurrentSupplierSummary = 'SET_CURRENT_SUPPLIER_SUMMARY',
  setSearch = 'SET_SEARCH',
  setWorkerId = 'SET_WORKER_ID',
}

//
type workingDayReconciliationPayload = {
  [workingDayReconciliationActionsTypes.setStartDate]: InitialStateType['startDate'];
  [workingDayReconciliationActionsTypes.setEndDate]: InitialStateType['endDate'];

  [workingDayReconciliationActionsTypes.setAdvancedFillter]: InitialStateType['advancedFillter'];
  [workingDayReconciliationActionsTypes.setCurrentSupplierSummary]: InitialStateType['currentSupplierSummary'];

  [workingDayReconciliationActionsTypes.setSearch]: InitialStateType['search'];
  [workingDayReconciliationActionsTypes.setWorkerId]: InitialStateType['workerId'];
};

export type Actions =
  IGeneral.ActionMap<workingDayReconciliationPayload>[keyof IGeneral.ActionMap<workingDayReconciliationPayload>];

export const workingDayReconciliationReducer = (
  state: InitialStateType,
  action: Actions
) => {
  switch (action.type) {
    case workingDayReconciliationActionsTypes.setStartDate:
      return {
        ...state,
        startDate: action.payload,
      };

    case workingDayReconciliationActionsTypes.setEndDate:
      return {
        ...state,
        endDate: action.payload,
      };
    case workingDayReconciliationActionsTypes.setAdvancedFillter:
      return {
        ...state,
        advancedFillter: action.payload,
      };

    case workingDayReconciliationActionsTypes.setCurrentSupplierSummary:
      return {
        ...state,
        currentSupplierSummary: action.payload,
      };
    case workingDayReconciliationActionsTypes.setSearch:
      return {
        ...state,
        search: action.payload,
      };
    case workingDayReconciliationActionsTypes.setWorkerId:
      return {
        ...state,
        workerId: action.payload,
      };
    default:
      return state;
  }
};
